// const PARSED_DATA = {
//     relatedLimit: 2,
//     relatedRemaining: 2,
//     relatedRowsLimit: 50,
//     serpLimit: 2,
//     serpRemaining: 2,
//     trackedKeywordLimit: 0,
//     upgradedAccount: false
// }

import { parseIntWithNVFallback } from 'sources/parsers/commons';

export const parse = rawData => ({
    backlinkLimit: parseInt(rawData.resources.links.limit, 10),
    backlinkRemaining: parseInt(rawData.resources.links.remaining, 10),
    backlinkResetSeconds: parseIntWithNVFallback(rawData.resources.links.reset),
    relatedLimit: parseInt(rawData.resources['related-keywords'].limit, 10),
    relatedRemaining: parseInt(rawData.resources['related-keywords'].remaining, 10),
    relatedResetSeconds: parseIntWithNVFallback(rawData.resources['related-keywords'].reset),
    relatedRowsLimit: parseInt(rawData['related-keywords-rows'], 10),
    serpLimit: parseInt(rawData.resources.serps.limit, 10),
    serpRemaining: parseInt(rawData.resources.serps.remaining, 10),
    serpResetSeconds: parseIntWithNVFallback(rawData.resources.serps.reset),
    siteLimit: parseInt(rawData.resources['sp-overview'].limit, 10),
    siteRemaining: parseInt(rawData.resources['sp-overview'].remaining, 10),
    siteResetSeconds: parseIntWithNVFallback(rawData.resources['sp-overview'].reset),
    trackedKeywordLimit: parseInt(rawData['tracked-keywords'], 10),
    // `on-demand-rank-scans` is the monthly resource key the API returns; it is declared in
    // api.mangools.com `config/limiter.js` and filled per plan in `services/limitsBuilder.js`.
    // Optional chaining, unlike the resources above: the key only exists once the API deploy that
    // introduced it is live, and 0 must be the answer until then so the refresh button stays off.
    onDemandRankScansRemaining: parseInt(rawData.resources?.['on-demand-rank-scans']?.remaining ?? 0, 10),
    upgradedAccount: rawData.upgraded_account,
    limitOptions: rawData.limit_options,
    trackings: rawData.trackings,
});
